import React from 'react';
import Logo from "../../assets/image/png/DronePlanet_Logo-removebg.png";

const links = [
  
  { label: 'Sell Drone & Accessories', url: '/enlist-new-drone' },
  { label: 'Enlist your Institute', url: '/enlist-your-institute' },
  { label: 'DaasConnect', url: '/aboutdaas' },
   { label: 'DroneXplore', url: '/DroneXplore' },
//   { label: 'Become a Dealer of Drone Planet', url: '/enterprise-dealer' },
//   { label: 'Become a DaaS Vendor', url: '/drone-sevices-page' },
//   { label: 'Enlist your RPTO', url: '/establishment-rpto' },
 
//   { label: 'Drone Pilot hiring Form', url: '#' },
//   { label: 'Internship opportunities', url: '#' },
//   { label: 'Website', url: '#' },
//   { label: 'Influencer Collaborations', url: '#' },
];

const LinktreePage = () => {
  return (
    <div className="min-h-screen bg-white text-center px-4 py-0">
      {/* Logo */}
      <div className="mb-6">
        <img
          src={Logo}
          alt="Drone Planet Logo"
          className="mx-auto w-40 h-15"
        />
      </div>

      {/* Title & Subtitle */}
      <h1 className="text-2xl font-bold mb-1">Drone Planet</h1>
      <p className="text-sm text-gray-600 mb-6">India’s Most Dependable Drone Startup</p>

      {/* Links */}
      <div className="flex flex-col items-center space-y-4">
        {links.map((link, index) => (
          <a
            key={index}
            href={link.url}
            // target="_blank"
            rel="noopener noreferrer"
            className="w-full max-w-md bg-white border border-black text-black py-3 px-6 rounded-full text-sm font-medium shadow hover:shadow-md hover:bg-gray-100 transition-all duration-200"
          >
            {link.label}
          </a>
        ))}
      </div>
    </div>
  );
};

export default LinktreePage;
